import GeneralAPI from "@/api/general";

export default {
  state: {
    countries: [],
  },
  mutations: {
    setCountries(state, countries) {
      let allCountries = [];
      countries.forEach(element => {
        allCountries.push({
          countryName: element.countryName,
          countryCode: element.countryCode,
        });
      });
      state.countries = allCountries;
    },
  },
  getters: {
    getCountries: state => {
      return state.countries;
    },
  },
  actions: {
    getCountries({ commit }) {
      return GeneralAPI.getCountries()
        .then(res => {
          commit("setCountries", res.data["hydra:member"][0].value);
        })
        .catch(err => console.error(err));
    },
  },
};
